import $ from "jquery"
// import { trace } from "./../shared/helpers.js"


const Horizonav = {

  $container : [],
  itemSelector: 'li:not(.horizonav-arrow)',
  activeItemClass: 'active',
  navClass: 'horizonav-arrow',
  navDisabledClass: 'horizonav-disabled',
  position: 0,
  maxPosition: 0,
  positionOutsideBounds: 0,
  num: 0, // number of items  
  transitionClass: 'horiznav-transition',


  removeEventListeners() {
    $("body").off("click", "." + this.navClass, this.move.bind(this));
  },
  
  move(e) {
    e.preventDefault();
    let $btn = $(e.currentTarget);
    let pos = 0;
    if ($btn.hasClass("right")) {
      pos = this.position + 1;
      if (pos <= this.maxPosition) {
        this.position = pos;
        this.update();
      }
    } else {
      pos = this.position - 1;
      if (pos >= 0) {
        this.position = pos;
        this.update();
      }      
    }
  },

  addEventListeners() {
    $("body").on("click", "." + this.navClass, this.move.bind(this));
  },

  updateNav() {
    let $leftArrow = this.$container.find("." + this.navClass + ".left");
    let $rightArrow = this.$container.find("." + this.navClass + ".right");
    if (this.position == 0) {
      $leftArrow.addClass(this.navDisabledClass);
    } else {
      $leftArrow.removeClass(this.navDisabledClass);
    }
    if (this.position == this.maxPosition || this.maxPosition > this.positionOutsideBounds) {
      $rightArrow.addClass(this.navDisabledClass);
    } else {
      $rightArrow.removeClass(this.navDisabledClass);
    }
  },

  updatePosition() {
    let $list = this.$container.find(this.itemSelector);
    let offset = 0;
    $list.each( (index, el)=> {
      if (index < this.position) {
        let $it = $(el);
        let itW = $it.outerWidth();
        offset += itW;
      }
    });
    $list.css("margin-left", -offset + "px");
  },

  update() {
    // trace("update", this.position);
    this.updateNav();
    this.updatePosition();
  },

  setInitialPosition() {
    let $list = this.$container.find(this.itemSelector);
    let pos = 0;
    $list.each( (index, el)=> {
      if ($(el).hasClass(this.activeItemClass)) {
        // trace("found active element", index);
        if (index >= this.positionOutsideBounds) {
          if (index <= this.maxPosition) {
            this.position = index
          } else {
            this.position = this.maxPosition;
          }
        }
      }
    });
  },

  refresh() {
    if (!this.$container.length) {
      return false;
    }
    this.kill();
    // trace("refresh", this.$container);
    // calculate full width (padding + items width)
    let iW = parseInt(this.$container.css("padding-left"));
    // container width
    let cW = this.$container.outerWidth();
    // container height
    let cH = this.$container.outerHeight();
    this.$container.css("height", cH + "px");
    let $list = this.$container.find(this.itemSelector);    
    this.num = $list.length;
    this.maxPosition = $list.length + 1;
    this.positionOutsideBounds = 0;
    // calculate maxPosition
    let revCW = iW;    
    $($list.get().reverse()).each( (index, el) => {
      if (revCW < cW) {
        this.maxPosition -= 1;
        let $it = $(el);
        let itW = $it.outerWidth();
        revCW += itW;        
      }
    });
    $list.each( (index, el)=> {
      let $it = $(el);
      let itW = $it.outerWidth();
      $it.css("position", "absolute");
      $it.css("left", iW + "px");
      iW += itW;
      if (iW >= cW && this.positionOutsideBounds == 0) {
        this.positionOutsideBounds = index;
      }
    });
    iW += parseInt(this.$container.css("padding-right"));
    if (iW > cW) {      
      this.addEventListeners();
      this.setInitialPosition();      
      setTimeout(()=> {
        // trace("add transition class");
        this.$container.addClass(this.transitionClass);
      }, 300);
    }
    this.update();

  },


  kill() {
    if (!this.$container.length) {
      return false;
    }
    // trace("kill", this.$container);
    this.removeEventListeners();
    this.$container.removeClass(this.transitionClass);
    this.$container.css("height", "auto");
    let $list = this.$container.find(this.itemSelector);
    $list.css("position", "static");
    $list.css("left", "auto");
    this.num = 0;
    this.position = 0;
    this.maxPosition = 0;
    this.positionOutsideBounds = 0;
  },

  init() {
    this.$container = $('.horizonav');
    if (this.$container.length) {
      this.refresh();
    }
  }
}

export default Horizonav;